import {PrimerComponentSubnavSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSubnav'

import {defineBrandPage, optionalTemplateField, orderedSections} from '../../../../brand/components/BrandPage'
import {
  findAllByContentType,
  GenericContentSchema,
  GenericSectionSchema,
  parseEntries,
  type GenericSection,
} from '../../../../brand/lib/types/contentful'

const COMPONENTS_WITH_NESTED_CONTENT = new Set(['DeepDive', 'Hero', 'Overview', 'RiverAccordion'])

export const universeRecapPage = defineBrandPage({
  nav: optionalTemplateField('subnav', PrimerComponentSubnavSchema),
  sections: orderedSections(GenericSectionSchema, toUniverseSectionContent),
})

function toUniverseSectionContent(section: GenericSection) {
  return {
    section,
    components: parseEntries(findAllByContentType(section.fields.content, 'genericContent'), GenericContentSchema).map(
      content => ({
        content,
        nestedContent:
          content.fields.id && COMPONENTS_WITH_NESTED_CONTENT.has(content.fields.id)
            ? parseEntries(findAllByContentType(content.fields.content, 'genericContent'), GenericContentSchema)
            : undefined,
      }),
    ),
  }
}
